import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-org-templates',
  templateUrl: './org-templates.component.html',
  styleUrls: ['./org-templates.component.scss']
})
export class OrgTemplatesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
